const _ = require('lodash');
const kConfig = require('./kpiConfig.js');

const technicalkpis = angular
  .module('common.technicalkpis', ['common.analytics'])
  .service('MetricsService', [
    'AnalyticsService',
    MetricsService
  ]);

function MetricsService(AnalyticsService) {

  var _trackState = _.reduce(kConfig, function(res, el, key) {
    res[key] = {
      state: null,
      initialStateTimestamp: null
    }

    return res
  }, {});

  function _shouldTrigger(kpi, checkpoint) {
    const currentState = _trackState[kpi].state;

    // no state, we should trigger
    if (currentState === null) {
      return true;
    }

    const currentStateIndex = parseInt(_.findKey(kConfig[kpi], {
      key: currentState
    }))
    const checkpointIndex = parseInt(_.findKey(kConfig[kpi], {
      key: checkpoint
    }))

    // only trigger if we are making progress
    return checkpointIndex > currentStateIndex;
  }

  function _trigger(kpi, checkpoint, options) {
    const time = _.get(options, 'time');

    const checkpointIndex = parseInt(_.findKey(kConfig[kpi], {
      key: checkpoint
    }))

    let performanceTime = new Date().getTime() - _trackState[kpi].initialStateTimestamp;

    if (checkpoint === 0 || _.get(options, 'forceNewFlow')) { // first element or new flow
      performanceTime = 0
    }
    else if (time) {
      performanceTime = time - performance.timing.navigationStart
    }

    const timestamp = time ? new Date(time).toISOString() : new Date().toISOString()

    // this item in the funnel, set initial timestamp
    if (checkpointIndex === 0) {
      var timestampInt = time ? new Date(time).getTime() : new Date().getTime()
      _.set(_trackState, [kpi, 'initialStateTimestamp'], timestampInt);
    }

    if (!_trackState[kpi].initialStateTimestamp) {
      return;
    }

    const name = _.find(kConfig[kpi], {key: checkpoint}).name
    console.log('TRACK', {kpi, name, checkpoint, performanceTime, checkpointIndex});
    AnalyticsService.track('[CORE] KPI', name, {
      checkpoint: checkpoint,
      timestamp: timestamp,
      performanceTimestamp: performanceTime
    });
    window.ga ('send', {
      hitType: 'timing',
      timingCategory: kpi,
      timingVar: name,
      timingValue: performanceTime
    });

    _.set(_trackState[kpi], 'state', checkpoint);
  }


  // exposed api
  return {
    init: function init() {
      this.track('appReady', 'userNavigationStarts', {
        time: performance.timing.navigationStart
      })
      this.track('appReady', 'requestStart', {
        time: performance.timing.requestStart
      })
      this.track('appReady', 'htmlRequest', {
        time: performance.timing.responseStart
      })
      this.track('appReady', 'jsReady', {
        time: new Date().getTime()
      })
    },
    track: function track(kpi, checkpoint, options) {
      if (!_.get(window, ['performance', 'timing'])) {
        return
      }

      if (!_.get(options, 'forceNewFlow') && !_shouldTrigger(kpi, checkpoint)) {
        return
      }
      _trigger(kpi, checkpoint, options);
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/technicalkpis/index.js